import React, { memo, useState } from 'react'
import PropTypes from 'prop-types'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import { faTimesCircle } from '@fortawesome/free-solid-svg-icons'

import Modal from '../modal'
import ModalBody from '../modalBody'
import FormGroup from '../formGroup'
import FormLabel from '../formLabel'
import FormInput from '../formInput'
import Button from '../button'
import { translate } from '../../helpers/stringHelpers'
import { listings, notifications } from '../../actions'

export const ContactSellerModal = ({
  isOpen,
  listingUuid,
  onClose
}) => {
  const [isAwaitingResponse, setAwaitingResponse] = useState(false)
  const [inputValue, setInputValue] = useState('')

  const dispatch = useDispatch()
  const listing = useSelector(state => state.lots.listings[listingUuid], shallowEqual)
  const userId = useSelector(state => state.users.user.id)
  if (!listing) return null
  const auctionUuid = listing.isMarketplace ? 'marketplace' : listing.auctionUuid

  if (!listing.contactSeller) return null

  const onChange = (e) => {
    setInputValue(e.target.value)
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    try {
      setAwaitingResponse(true)
      await dispatch(listings.contactSeller(listing.id, userId, listing.title, inputValue))

      const successMessage = translate('JspPublicCodes_JSP_CONTACT_SELLER_MESSAGE_TO_SELLER')
      dispatch(notifications.addAuctionNotification(auctionUuid, listingUuid, 'info', successMessage))
      onClose()
      setInputValue('')
    } catch (err) {
      dispatch(notifications.addAuctionNotification(auctionUuid, listingUuid, 'danger', translate('JspPublicCodes_JSP_CONTACT_SELLER_ERROR'), faTimesCircle))
    }
    setAwaitingResponse(false)
  }
  return (
    <Modal onClose={onClose} isOpen={isOpen} id='contactModal'>
      <ModalBody>
        <h4 className='modal__primary-title'>{translate('JspPublicCodes_JSP_BIDDING_CONTACT_SELLER')}</h4>
        <h5>{listing.title}</h5>
        <div className='text-muted' dangerouslySetInnerHTML={{ __html: translate('JspPublicCodes_JSP_CONTACT_SELLER_ABOUT') }} />
        <form
          className='contact-seller__form' onSubmit={handleSubmit}
        >
          <FormGroup>
            <FormLabel for='contactSeller__input'>{translate('JspPublicCodes_JSP_CONTACT_SELLER_YOUR_MESSAGE')}</FormLabel>
            <FormInput id='contactSeller__input' dataRef='contactInput' type='textarea' onChange={onChange} value={inputValue} />
          </FormGroup>
          <Button
            id='contactSeller__cancel'
            onClick={onClose}
          >
            {translate('JSTextCodes_CANCEL')}
          </Button>
          <Button
            disabled={isAwaitingResponse}
            id='contactSeller__submit'
            type='submit'
            color='primary'
            className='pull-right'
          >
            {translate('JSTextCodes_SEND')}
          </Button>
        </form>
      </ModalBody>
    </Modal>
  )
}

ContactSellerModal.propTypes = {
  isOpen: PropTypes.bool,
  listingUuid: PropTypes.string,
  onClose: PropTypes.func.isRequired
}

const isEqual = (a, b) => a.isOpen === b.isOpen &&
  a.listingUuid === b.listingUuid

export default memo(ContactSellerModal, isEqual)
